import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'

export interface VaccineProps {
  data: {
    descricao: string,
    dose: string,
    tipo: string
  },
  idVacina: string
}

export interface VaccineStoreProps {
  data?: {
    descricao?: string,
    dose?: string,
    tipo?: string
  },
  idVacina?: string
}

export interface VaccineState {
  list: Array<VaccineProps>
}

const customModule = '@VACCINE'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const STORE = {
  REQUEST: `${customModule}/STORE_REQUEST`,
  SUCCESS: `${customModule}/STORE_SUCCESS`,
}
const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`,
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: VaccineState = {
  list: [],
}

export const vaccineReducer: Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case GET.SUCCESS:
    return { ...state, list: payload }

  case STORE.SUCCESS: {
    const { list } = state
    const newList = [...list]
    newList.unshift(payload)
    return { ...state, list: newList }
  }

  case UPDATE.SUCCESS: {
    const { list } = state
    const newList = list.map((item: any) => {
      if (item.idVacina === payload.idVacina) return payload
      return item
    })
    return { ...state, list: newList }
  }
  default:
    return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getVaccine = (data: string) => ({ type: GET.REQUEST, payload: data })
export const createVaccine = (data: VaccineStoreProps) => ({ type: STORE.REQUEST, payload: data })
export const updateVaccine = (data: VaccineStoreProps) => ({ type: UPDATE.REQUEST, payload: data })

const ROUTE = '/domain/Vacina'

// eslint-disable-next-line
function* get({ payload }: SagaAction<any>) {
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, ROUTE, { params: payload })
    yield put({ type: GET.SUCCESS, payload: data })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar Vacinas. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

// eslint-disable-next-line
function* store({ payload }: SagaAction<VaccineStoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(`${ROUTE}/`, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Cadastrado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Cadastrar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: STORE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

// eslint-disable-next-line
function* update({ payload }: SagaAction<VaccineStoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(`${ROUTE}/${payload.idVacina}/'idLote`, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Atualizado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Atualizar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: UPDATE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}


export const vaccineSaga = all([
  takeLatest(GET.REQUEST, get),
  takeLatest(STORE.REQUEST, store),
  takeLatest(UPDATE.REQUEST, update),
])
